import React from "react";

export default function Step3({ data, setData }) {
  return (
    <div>
      <h3>Trúnaðar- og persónuverndaryfirlýsing</h3>

      <label className="checkbox">
        <input
          type="checkbox"
          checked={data.accepts_confidentiality_agreement === true}
          onChange={(e) =>
            setData((d) => ({ ...d, accepts_confidentiality_agreement: e.target.checked }))
          }
        />
        Ég hef skrifað undir trúnaðaryfirlýsingu Hugarafls*
      </label>
      <p>Ég hef skrifað undir sér blað um upplýst samþykki og ég samþykki að Hugarafli sé heimilt að vinna persónuupplýsingar um mig í samræmi við 10.gr. laga um persónuvernd og vinnslu persónuupplýsinga nr. 90/2018.*</p>
      <div className="checkbox" style={{ marginTop: 12 }}>
        <label className="checkbox">
          <input
            type="checkbox"
            required
            checked={data.informed_consent === true}
            onChange={(e) =>
              setData((d) => ({ ...d, informed_consent: e.target.checked }))
            }
          />
          Já, ég hef skrifað undir.*
        </label>
      </div>
    </div>
  );
}